import React from 'react';
import { connect } from 'react-redux';
import { Formik } from 'formik';
import Typography from '@material-ui/core/Typography';
import { Link } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import PropTypes from 'prop-types';
import { changeUserPassword } from '../../actions/users';
import authenticationErrorFormSchema from './AuthenticationErrrorFormSchema';

const messages = {
  'Please%20change%20your%20password': 'Oops, It looks like your password has expired',
  'User%20did%20not%20accept%20privacy%20terms':
    'You must accept the privacy terms in order to use Episource applications',
};

const useStyles = makeStyles(theme => ({
  page: {
    margin: '40px',
    textAlign: 'center',
  },
  form: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  selectRow: {
    display: 'flex',
    marginLeft: theme.spacing(1),
  },
  nameRow: {
    display: 'flex',
    marginTop: theme.spacing(1),
  },
  header: {
    margin: 'auto',
    width: '50%',
    marginTop: '10%',
    marginBottom: theme.spacing(10),
  },
  title: {
    marginBottom: theme.spacing(3),
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  paper: {
    margin: 'auto',
    width: '50%',
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
  },
  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1),
  },
}));

const AuthenticationError = ({ message, changeUserPassword: sendPasswordResetEmail }) => {
  const classes = useStyles();
  const redirectOnSuccess = true;

  return (
    <div className={classes.page}>
      <h1 className={classes.header}>{messages[message] || message}</h1>
      {message !== 'User%20did%20not%20accept%20privacy%20terms' ? (
        <Paper className={classes.paper}>
          <Formik
            initialValues={{ email: '' }}
            onSubmit={(values, { setSubmitting }) => {
              setSubmitting(true);
              sendPasswordResetEmail(values.email, redirectOnSuccess);
            }}
            validationSchema={authenticationErrorFormSchema}
          >
            {formikProps => {
              const {
                values,
                touched,
                errors,
                isSubmitting,
                handleChange,
                handleBlur,
                handleSubmit,
              } = formikProps;
              return (
                <form autoComplete="off" onSubmit={handleSubmit}>
                  <div className={classes.form}>
                    <Typography variant="h5" className={classes.title}>
                      Please enter the email associated with your account
                    </Typography>
                    <Grid container spacing={3}>
                      <Grid item xs={12} sm={12}>
                        <TextField
                          required
                          error={errors.email ? touched.email : null}
                          className={classes.textField}
                          label="Email"
                          name="email"
                          value={values.email}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          variant="outlined"
                          helperText={errors.email && touched.email ? errors.email : ''}
                          fullWidth
                        />
                      </Grid>
                    </Grid>
                    <Button
                      variant="contained"
                      color="primary"
                      type="submit"
                      className={classes.button}
                      disabled={isSubmitting}
                    >
                      Send Password Reset Email
                    </Button>
                  </div>
                </form>
              );
            }}
          </Formik>
        </Paper>
      ) : (
        <>
          <Link to="/">
            <Button variant="contained" color="primary" type="submit" className={classes.button}>
              Log In
            </Button>
          </Link>
        </>
      )}
    </div>
  );
};

AuthenticationError.defaultProps = {
  changeUserPassword: () => {},
  message: null,
};

AuthenticationError.propTypes = {
  changeUserPassword: PropTypes.func,
  message: PropTypes.string,
};

export const AuthenticationErrorPage = connect(undefined, { changeUserPassword })(
  AuthenticationError
);
export default AuthenticationErrorPage;
